import { Component } from '@angular/core';


import { ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import Swal from 'sweetalert2'
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { RouterLink } from '@angular/router';
import { SHARED_IMPORTS } from 'src/app/shared-imports';
declare var bootstrap: any;
import { MatTableDataSource } from '@angular/material/table';
import { HasRoleDirective } from 'src/app/shared/directive/has-role.directive';
import { MatPaginator } from '@angular/material/paginator';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { RequestsService } from 'src/app/shared/service/requests/requests.service';

@Component({
  selector: 'app-incoming-requests',
  imports: [
    SHARED_IMPORTS,
    ReactiveFormsModule,
    DatePipe,
    RouterLink,
    HasRoleDirective,
  ],
  templateUrl: './requests.component.html',
  styleUrl: './requests.component.scss'
})
export class RequestsComponent {
  genders: any = [{ _id: 'Hospital', name: "Hospital" }, { _id: "Home", name: "Home" }];

  // =============================
  // 🔹 All Variables on Top
  // =============================
  formType: string = 'Add';
  categoryModal: any;
  startpoint = 0;
  search: any;
  totalLoaded = 0;
  total = 0;
  pageNo = 0;
  categoryRes: any;
  categoryId: any;
  pageSize: number = 10;
  name: any;
  displayedColumns: string[] = ['position',
    'fromWard',
    'toWard',
    'person',
    'remarks',
    'action'
    ];
  dataSource = new MatTableDataSource<any>([]);
  isCompanyLoggedIn: boolean = false;
  debounceTimer: any = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('fileInput') fileInput!: ElementRef;

  categoryForm = new FormGroup({
    _id: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    category_image: new FormControl('', [Validators.required]),
    location: new FormControl(''),
    gender: new FormControl<any>(1), // 1 Male // 2: Female
    description: new FormControl('')
  });

  // =============================
  // 🔹 Constructor
  // =============================
  constructor(
    private requestsService: RequestsService,
    private wardService: CompanyService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService
  ) {
    this.setDisplayedColumns();
  }

  // =============================
  // 🔹 Lifecycle Hooks
  // =============================
  ngOnInit(): void {
    this.getCompanyData();
    this.getAllWards();
  }

  wardsList: any[] = [];
  getAllWards() {
    this.wardService.allCompanies({}).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.wardsList = res.data;
        }
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const modalElement = document.getElementById('wardModal');
    if (modalElement) {
      this.categoryModal = new bootstrap.Modal(modalElement);
    }
  }

  // =============================
  // 🔹 Column Setup
  // =============================
  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position',
      'fromWard',
      'toWard',
      'person',
      'remarks',
      'action'
    ];
    // if (this.userDataService.roleMatch(['CATEGORY-DELETE'])) {
    //   this.displayedColumns.push('isBlocked');
    // }
    // if (this.userDataService.roleMatch(['CATEGORY-EDIT'])) {
    //   this.displayedColumns.push('action');
    // }
  }

  // =============================
  // 🔹 Utility Methods
  // =============================
  onSearchChange(event: any) {
    const value = event.target.value.trim();
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.name = value || undefined;
      this.getAllCategories(null);
    }, 200);
  }

  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath;
  }

  clearForm() {
    this.categoryForm.reset();
    if (this.fileInput) this.fileInput.nativeElement.value = '';
  }

  // =============================
  // 🔹 Modal Logic
  // =============================
  openModel(type: string, categoryId: any) {
    this.formType = type;
    this.categoryId = categoryId;

    if (categoryId !== null) {
      this.spinner.show();
      this.wardService.singleCompany({ _id: categoryId }).subscribe({
        next: (v: any) => {
          this.spinner.hide();
          if (v.success) {
            this.categoryForm.patchValue({
              name: v.data?.name,
              category_image: v.data?.image,
              gender: v?.data?.type
            });
          } else {
            this.toastr.error(v.message);
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          this.toastr.error(e.message, 'Error');
        },
      });
    }
    this.categoryModal.show();
  }

  hideModel() {
    this.clearForm();
    this.categoryModal.hide();
  }

  uploadImage(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    // File type validation
    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
      this.toastr.info("Only JPG, JPEG and PNG images are allowed.");
      event.target.value = "";
      return;
    }

    // Check aspect ratio
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      this.categoryForm.patchValue({ category_image: file });

      // const aspectRatio = img.width / img.height;
      // if (Math.abs(aspectRatio - 16 / 9) < 0.01) {   // 16:9 ratio (allowing small tolerance)
      // } else {
      //   this.toastr.error("Image aspect ratio must be 16:9.");
      //   event.target.value = "";
      // }
    };
  }

  // =============================
  // 🔹 Company Data Check
  // =============================
assignedWard: any;
userData: any;

getCompanyData() {
  this.userData = this.userDataService.getData();

  // 👇 extract assigned ward
  this.assignedWard = this.userData?.data?.assignedWardNew;
  console.log(JSON.stringify(this.userData))

  this.isCompanyLoggedIn = !!this.userData?.company;

  this.getAllCategories(null);
}

  // =============================
  // 🔹 Category Fetch
  // =============================
  getAllCategories(event: any) {
    this.spinner.show();

    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || PAGELENGTH;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize || PAGELENGTH,
    };
    if (this.assignedWard.length>0) {
      data.toWardId = this.assignedWard;
    }

    if (this.userData?.data?.userType == 9) {
      data.isReceptionRole = true;
    }

    if (this.name) data.name = this.name;
    if (this.isCompanyLoggedIn) data.isBlocked = false;

    // Flag to get know is request is incoming or outgoing
    data.isIncoming = true;

   this.requestsService.wardLogpendingRequests(data).subscribe({
  next: (result) => {
    console.log("API RESPONSE:", result);

    this.spinner.hide();

   const res = result.body || result;

if (res.success) {
  this.dataSource.data = res.data || [];
  this.total = res.data?.length || 0;
}
  },
  error: (e) => {
    this.spinner.hide();
    this.toastr.error(e.message);
  }
});
  }

hitAcceptRejectAPI(payload: any) {
  this.spinner.show();


  console.log(payload);

  this.requestsService.acceptrejectRequest(payload).subscribe({
    next: (res: any) => {
      this.spinner.hide();

      if (res.success) {
        this.toastr.success(res.message || 'Success');

        // Refresh table
        this.getAllCategories(null);
      } else {
        this.toastr.error(res.message);
      }
    },
    error: (err: any) => {
      this.spinner.hide();
      this.toastr.error(err.message || 'Error');
    }
  });
}

  handleRequest(element: any, isAccept: boolean) {
    if (isAccept) {
      Swal.fire({
        title: 'Accept Request',
        html: `
          <div class="form-group text-start">
            <label class="mb-1 fw-bold">Select Ward (Required)</label>
            <select id="swal-input1" class="form-select mb-3">
              <option value="">-- Select Ward --</option>
              ${this.wardsList.map(w => `<option value="${w._id}" ${element.toWardId?._id === w._id ? 'selected' : ''}>${w.name} ${w.type ? '(' + w.type + ')' : ''}</option>`).join('')}
            </select>
            <label class="mb-1 fw-bold">Remarks (Optional)</label>
            <textarea id="swal-input2" class="form-control" placeholder="Write remarks here..."></textarea>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Accept',
        preConfirm: () => {
          const wardId = (document.getElementById('swal-input1') as HTMLInputElement).value;
          const remarks = (document.getElementById('swal-input2') as HTMLInputElement).value;
          if (!wardId) {
            Swal.showValidationMessage('Please select a Ward');
            return false;
          }
          return { toWardId: wardId, remarks: remarks };
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const payload = {
            _id: element._id,
            isAccept: true,
            toWardId: result.value.toWardId,
            remarks: result.value.remarks
          };
          alert(JSON.stringify(payload))
          this.hitAcceptRejectAPI(payload);
        }
      });
    } else {
      Swal.fire({
        title: 'Reject Request',
        input: 'textarea',
        inputLabel: 'Enter Remarks',
        inputPlaceholder: 'Write remarks here...',
        inputAttributes: {
          'aria-label': 'Type your remarks here'
        },
        showCancelButton: true,
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            _id: element._id,
            isAccept: false,
            // remarks: result.value
          };
          this.hitAcceptRejectAPI(payload);
        }
      });
    }
  }

  updateWardRequest(element: any) {
    Swal.fire({
      title: 'Update Ward',
      html: `
        <div class="form-group text-start">
          <label class="mb-1 fw-bold">Select Ward (Required)</label>
          <select id="swal-update-ward" class="form-select mb-3">
            <option value="">-- Select Ward --</option>
            ${this.wardsList.map(w => `<option value="${w._id}" ${element.toWardId?._id === w._id ? 'selected' : ''}>${w.name} ${w.type ? '(' + w.type + ')' : ''}</option>`).join('')}
          </select>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Update',
      preConfirm: () => {
        const wardId = (document.getElementById('swal-update-ward') as HTMLInputElement).value;
        if (!wardId) {
          Swal.showValidationMessage('Please select a Ward');
          return false;
        }
        return { wardId: wardId };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const payload = {
          requestId: element._id,
          wardId: result.value.wardId
        };
        this.spinner.show();
        this.requestsService.updateWardIdInRequest(payload).subscribe({
          next: (res: any) => {
            this.spinner.hide();
            if (res.success) {
              this.toastr.success(res.message || 'Ward updated successfully');
              this.getAllCategories(null);
            } else {
              this.toastr.error(res.message);
            }
          },
          error: (err: any) => {
            this.spinner.hide();
            this.toastr.error(err.message || 'Error');
          }
        });
      }
    });
  }

  // =============================
  // 🔹 Submit Handler
  // =============================
  submit() {
    this.spinner.show();

    const data = new FormData();
    let name = this.categoryForm.value.name;
    const gender: any = this.categoryForm.value.gender;
    const templocation: any = this.categoryForm.value.location;
    if (templocation) {
      name = name + " (" + templocation + ")";
    }
    if (gender) {
      name = name + " (" + gender + ")";
    }

    data.append('name', name ?? '');
    data.append('ward_image', this.categoryForm.value.category_image ?? '');
    data.append('description', 'MDSS Wards');
    data.append('type', gender);
    data.append('location', templocation)

    if (this.formType === 'Add') {
      this.wardService.addCompany(data).subscribe({
        next: (v: any) => {
          this.spinner.hide();
          if (v.success) {
            this.toastr.success(v.message, 'Success');
            this.hideModel();
            this.getAllCategories(null);
          } else {
            this.toastr.error(v.message, 'Error');
            this.hideModel();
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          this.toastr.error(e.message, 'Error');
          this.hideModel();
        },
        complete: () => {
          this.spinner.hide();
          this.hideModel();
        },
      });
    } else {
      data.append('_id', this.categoryId ?? '');
      this.wardService.updateCompany(data).subscribe({
        next: (v: any) => {
          this.spinner.hide();
          if (v.success) {
            this.toastr.success(v.message, 'Success');
            this.hideModel();
            this.getAllCategories(null);
          } else {
            this.toastr.error(v.message, 'Error');
            this.hideModel();
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          this.toastr.error(e.message, 'Error');
          this.hideModel();
        },
        complete: () => {
          this.spinner.hide();
          this.hideModel();
        },
      });
    }
  }

  // =============================
  // 🔹 Block/Unblock Handler
  // =============================
  onToggleClick(element: any) {
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Block' : 'Unblock';

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `${action} this category?`,
        text: `This will ${action.toLowerCase()} the category.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.wardService
            .enableDisableCompany({ _id: element._id, isBlocked: newStatus })
            .subscribe({
              next: (v: any) => {
                if (v.success) {
                  element.isBlocked = newStatus;
                  this.toastr.success(`Category ${action.toLowerCase()}ed successfully.`);
                } else {
                  this.toastr.error(v.message, 'Error');
                }
              },
              error: (e: any) => {
                this.toastr.error(e.message, 'Error');
              },
            });
        }
      });
    return false;
  }
}
